var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttendenceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_186_44794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9411 5.52179L18.6584 4.80454L19.4227 5.56884C19.4878 5.63384 19.5731 5.6665 19.6584 5.6665C19.7437 5.6665 19.8292 5.63384 19.8941 5.56884C20.0245 5.43852 20.0245 5.22786 19.8941 5.09754L17.8941 3.0975C17.7641 2.96718 17.5528 2.96718 17.4228 3.0975C17.2925 3.22782 17.2925 3.43849 17.4228 3.5688L18.1871 4.33328L17.4314 5.08901C16.268 4.18466 14.8607 3.58008 13.3251 3.39532L13.3252 2.33328H14.3253C14.5092 2.33328 14.6587 2.18432 14.6587 1.99989L14.6585 0.333396C14.6585 0.149127 14.5092 0 14.3251 0H10.3252C10.1412 0 9.99176 0.148963 9.99176 0.333396V2.00006C9.99176 2.18432 10.1411 2.33345 10.3252 2.33345H11.3252V3.39549C9.01746 3.67263 6.99817 4.89702 5.66534 6.6666H7.9917C8.17564 6.6666 8.3251 6.81556 8.3251 7C8.3251 7.18427 8.1758 7.33339 7.9917 7.33339L5.21136 7.33323C4.8933 7.85318 4.63777 8.41359 4.43865 8.99989H6.992C7.17594 8.99989 7.3254 9.14885 7.3254 9.33328C7.3254 9.51755 7.1761 9.66668 6.992 9.66668H4.24333C4.11037 10.204 4.03036 10.7611 4.00726 11.3333H7.99154C8.17548 11.3333 8.32494 11.4823 8.32494 11.6667C8.32494 11.851 8.17564 12.0001 7.99154 12.0001L4 12C4.0226 12.5719 4.10294 13.1297 4.23607 13.6666H6.65841C6.84235 13.6666 6.99181 13.8156 6.99181 14C6.99181 14.1843 6.84251 14.3334 6.65841 14.3334H4.43168C4.63063 14.9207 4.89129 15.4795 5.20967 16.0001H5.65838C5.84231 16.0001 5.99177 16.149 5.99177 16.3335C5.99177 16.5164 5.84446 16.6637 5.6625 16.6662C7.1843 18.689 9.60454 20 12.3249 20C16.9197 20 20.658 16.2617 20.658 11.6669C20.658 9.2348 19.608 7.04637 17.9407 5.52224L17.9411 5.52179ZM16.8941 7.56888L13.7078 10.7555C13.8798 11.0178 13.9818 11.3303 13.9818 11.6665C13.9818 12.5855 13.2341 13.3331 12.3151 13.3331C11.9784 13.3331 11.6661 13.2312 11.4042 13.0591L10.4394 14.0238C10.3744 14.0888 10.2892 14.1215 10.2037 14.1215C10.1184 14.1215 10.033 14.0888 9.96797 14.0238C9.83765 13.8935 9.83765 13.6829 9.96797 13.5525L10.9296 12.5909C10.7526 12.3263 10.6486 12.0086 10.6486 11.667C10.6486 10.7479 11.3963 10.0003 12.3153 10.0003C12.6569 10.0003 12.9747 10.1042 13.2393 10.2816L16.4226 7.09786C16.5526 6.96754 16.7636 6.96754 16.8939 7.09786C17.0244 7.22819 17.0244 7.43852 16.8941 7.56883L16.8941 7.56888Z",
    fill: "#092C4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_186_44794",
    x: 0,
    y: 0,
    width: 24.6582,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_186_44794"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_186_44794",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendenceIcon);
export default __webpack_public_path__ + "static/media/AttendenceIcon.44493538c29c735f65a4d401a4369de7.svg";
export { ForwardRef as ReactComponent };